import { useState, useEffect } from 'react';
import { updateMetaTags } from '../../utils/seo';

export default function MentionsLegalesPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    updateMetaTags({
      title: 'Mentions légales - Vist Magazine',
      description: 'Mentions légales du magazine digital Vist. Informations sur l\'éditeur, l\'hébergement et les conditions d\'utilisation du site.',
      keywords: 'mentions légales, vist magazine, informations légales, éditeur',
      canonical: '/mentions-legales'
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="text-xl md:text-2xl font-bold text-gray-900">Vist</a>
            <div className="hidden md:flex items-center gap-8">
              <a href="/" className="text-sm text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">Accueil</a>
              <a href="/magazine" className="text-sm text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">Magazine</a>
              <a href="/blog" className="text-sm text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">Blog</a>
              <a href="/a-propos" className="text-sm text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">À propos</a>
              <a href="/contact" className="text-sm text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">Contact</a>
            </div>
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors cursor-pointer"
            >
              <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl text-gray-900`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
            <div className="px-4 py-4 space-y-3">
              <a href="/" className="block py-2 text-sm text-gray-600 hover:text-gray-900 transition-colors">Accueil</a>
              <a href="/magazine" className="block py-2 text-sm text-gray-600 hover:text-gray-900 transition-colors">Magazine</a>
              <a href="/blog" className="block py-2 text-sm text-gray-600 hover:text-gray-900 transition-colors">Blog</a>
              <a href="/a-propos" className="block py-2 text-sm text-gray-600 hover:text-gray-900 transition-colors">À propos</a>
              <a href="/contact" className="block py-2 text-sm text-gray-600 hover:text-gray-900 transition-colors">Contact</a>
            </div>
          </div>
        )}
      </nav>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-8 md:mb-12">Mentions légales</h1>

        <div className="prose prose-sm md:prose-base max-w-none space-y-8">
          <section>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">1. Éditeur du site</h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-3">
              Le site Vist Magazine est édité par :
            </p>
            <ul className="list-disc pl-6 space-y-2 text-sm md:text-base text-gray-700">
              <li><strong>Nom :</strong> Vist Magazine</li>
              <li><strong>Forme juridique :</strong> Magazine digital indépendant</li>
              <li><strong>Directeur de la publication :</strong> Jules</li>
              <li><strong>Contact :</strong> <a href="/contact" className="text-amber-600 hover:text-amber-700 underline cursor-pointer">Page de contact</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">2. Hébergement</h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-3">
              Le site est hébergé par :
            </p>
            <ul className="list-disc pl-6 space-y-2 text-sm md:text-base text-gray-700">
              <li><strong>Hébergeur :</strong> Readdy.ai</li>
              <li><strong>Site web :</strong> <a href="https://readdy.ai" target="_blank" rel="noopener noreferrer" className="text-amber-600 hover:text-amber-700 underline cursor-pointer">https://readdy.ai</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">3. Propriété intellectuelle</h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-3">
              L'ensemble du contenu de ce site (textes, images, vidéos, graphismes, logos, icônes, etc.) est la propriété exclusive de Vist Magazine, sauf mention contraire.
            </p>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-3">
              Toute reproduction, distribution, modification, adaptation, retransmission ou publication de ces différents éléments est strictement interdite sans l'accord exprès par écrit de Vist Magazine.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">4. Données personnelles</h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-3">
              Les informations recueillies sur ce site font l'objet d'un traitement informatique destiné à la gestion des demandes de contact et à l'envoi de notre newsletter.
            </p>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-3">
              Conformément à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données vous concernant.
            </p>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-3">
              Pour exercer ces droits, veuillez nous contacter via notre <a href="/contact" className="text-amber-600 hover:text-amber-700 underline cursor-pointer">page de contact</a>.
            </p>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              Pour plus d'informations, consultez notre <a href="/confidentialite" className="text-amber-600 hover:text-amber-700 underline cursor-pointer">Politique de confidentialité</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">5. Cookies</h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-3">
              Ce site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. En naviguant sur ce site, vous acceptez l'utilisation de ces cookies.
            </p>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              Vous pouvez à tout moment désactiver les cookies dans les paramètres de votre navigateur.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">6. Responsabilité</h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-3">
              Vist Magazine s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, nous ne pouvons garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition.
            </p>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              En conséquence, Vist Magazine décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">7. Liens hypertextes</h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-3">
              Ce site peut contenir des liens vers d'autres sites internet. Vist Magazine n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">8. Droit applicable</h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.
            </p>
          </section>

          <section className="pt-6 border-t border-gray-200">
            <p className="text-xs md:text-sm text-gray-500">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-amber-50 via-rose-50 to-orange-50 py-12 md:py-16 mt-12 md:mt-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Vist</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Magazine digital indépendant consacré à l'analyse des tendances culturelles, sociétales et digitales.
              </p>
            </div>

            <div>
              <h4 className="text-sm font-bold text-gray-900 mb-4">Navigation</h4>
              <ul className="space-y-2">
                <li><a href="/" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Accueil</a></li>
                <li><a href="/magazine" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Magazine</a></li>
                <li><a href="/blog" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Blog</a></li>
                <li><a href="/a-propos" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">À propos</a></li>
                <li><a href="/contact" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Contact</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-gray-900 mb-4">Légal</h4>
              <ul className="space-y-2">
                <li><a href="/mentions-legales" className="text-sm text-gray-900 font-medium cursor-pointer">Mentions légales</a></li>
                <li><a href="/confidentialite" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Confidentialité</a></li>
                <li><a href="/conditions" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Conditions</a></li>
              </ul>
            </div>
          </div>

          <div className="pt-6 md:pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-600 text-center">
              © {new Date().getFullYear()} Vist Magazine. Tous droits réservés. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 transition-colors">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
